/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import { Modal } from "react-bootstrap";
import BaseCom from "../BaseCom";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import Icon from "../Icon";
import FormInput from "../FormInput";
import React from "react";
import { qreq } from "../../shared/qrequest";

class SurveyAdminEditItem extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            page: props.page,
            item: props.item,
            types: [
                { id: 'radio', name: 'Pick One', picker: true },
                { id: 'select', name: 'Dropdown Pick', picker: true },
                { id: 'text', name: 'Text Input', picker: false },
                { id: 'email', name: 'Email Input', picker: false },
                { id: 'number', name: 'Number Input', picker: false },
                { id: 'textarea', name: 'Multiline Text Input', picker: false },
                { id: 'label', name: 'Label', picker: false }
            ]
        };
        this.form = React.createRef();
        this.getType = this.getType.bind(this);
        this.onChange = this.onChange.bind(this);
        this.addAnswer = this.addAnswer.bind(this);
        this.removeAnswer = this.removeAnswer.bind(this);
        this.submit = this.submit.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.item !== this.props.item) {
            this.setState({ item: this.props.item });
        }
        if (prevProps.page !== this.props.page) {
            this.setState({ page: this.props.page });
        }
    }

    getType(id) {
        var find = this.state.types.find(a => a.id === id);
        if (find)
            return find;
        return {};
    }

    addAnswer() {
        var item = {...this.state.item};
        item.answers.push({});
        this.setState({ item: item });
    }

    removeAnswer(i) {
        var item = {...this.state.item};
        item.answers.splice(item.answers.indexOf(i), 1)
        this.setState({ item: item });
    }

    onChange(v, updateVarName) {
        this.setState({ item: {...this.state.item} });
        if(updateVarName) {
            qreq.post('/api/survey/item/varname', {...this.state.item}, j => {
                if(j.item)
                    this.setState({ item: {...this.state.item, varName: j.item.varName }})
            });
        }
    }

    submit(e) {
        if(e) e.preventDefault();
        var item = {...this.state.item};
        if(!this.getType(item.itemType).picker)
            item.answers = [];

        
        var find = this.props.page.items.find(a => { if(item.key) return a.key === item.key; else return a.id === item.id; });

        if(find)
            this.props.page.items.splice(this.props.page.items.indexOf(find), 1, item);
        else
            this.props.page.items.push(item);

        this.props.onSubmit(item);
        this.props.onHide();
    }

    render() {
        if (!this.state.item)
            return '';
        return <form onSubmit={this.submit} ref={this.form}>
            <Modal show={this.props.show} onHide={this.props.onHide} size="xl">
            <Modal.Header>
                <Modal.Title>Edit Item</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <h4 className="mb-2">Question</h4>
                <FormInput model={this.state.item} name="itemType" label="Type" type="select" options={this.state.types} required onChange={this.onChange} />
                <FormInput model={this.state.item} name="content" label="Text" type="textarea" required onChange={v => this.onChange(v, true)} rows={2} />
                <FormInput model={this.state.item} name="isOptional" label="Optional" type="switch" onChange={this.onChange} />
                {this.state.item.varName ? <div className="mb-3">
                    <label className="form-label">Variable Name</label>
                    <div className="text-success">@{this.state.item.varName}</div>
                </div> : ''}
                <FormInput model={this.state.item} name="descriptor" label="Descriptor" type="textarea" onChange={this.onChange} rows={4} placeholder="Leave blank for none." />
                {this.getType(this.state.item.itemType).picker ? <>
                    <h4 className="mb-2">Answers</h4>
                    <div className="list-group">
                        {this.state.item.answers.map(i => <div key={i.id} className="list-group-item d-flex">
                            <div className="flex-fill">
                                <FormInput model={i} name="content" label="Answer Text" type="text" labelAsPlaceholder required inputGroupClassName="mb-0" />
                            </div>
                            <div className="ms-2">
                                <FormInput model={i} name="score" label="Score (0)" type="number" step={1} labelAsPlaceholder required inputGroupClassName="mb-0" />
                            </div>
                            <div className="ms-2">
                                <button type="button" className="btn btn-danger" onClick={() => this.removeAnswer(i)}><Icon icon="faTrash" /></button>
                            </div>
                        </div>)}
                    </div>
                    <div className="mt-3">
                        <button type="button" className="btn btn-primary" onClick={() => this.addAnswer()}><Icon icon="faPlus" /> Add Answer</button>
                    </div>
                    </> : ''}
            </Modal.Body>
            <Modal.Footer>
                <div className="btn-group text-end">
                    <button type="button" className="btn btn-success btn-lg" onClick={() => this.form.current.requestSubmit()}><Icon icon="faSave" /> Save</button>
                    <button type="button" className="btn btn-secondary btn-lg" onClick={this.props.onHide}><Icon icon="faCancel" /> Cancel</button>
                </div>
            </Modal.Footer>
        </Modal>
        </form>;
    }
}

export default withParamsAndNavigate(SurveyAdminEditItem);